import IApi from 'modules/shared/domain/IApi';
import api from 'modules/shared/infrastructure/api/Api';
import BaseRepository from 'modules/shared/infrastructure/repositories/BaseRepository';
import ITrucksInfoRepository from './ITrucksInfoRepository';
import * as URL from './urls';
import {
  TrucksInAreaListDTO,
  TrucksInAreaParkingListDTO,
  TrucksInPlantByPointInfoListDTO,
  UnloadingPointsAverageDlzInfoListDTO
} from '../dto/TrucksInfoDTO';
import { TrucksInfoMapper } from '../mappers/TrucksInfo.mapper';

class TrucksInfoRepository
  extends BaseRepository
  implements ITrucksInfoRepository
{
  private readonly _api: IApi;
  private readonly _apiGetTrucksInPlantByWorkshop: string;
  private readonly _apiGetTrucksInParking: string;
  private readonly _apiGetUnloadingPointsAverageDlz: string;
  private readonly _apiGetTrucksInPlantUnloadingBuffer: string;
  private readonly _apiGetTrucksInPlantWaitingToArrive: string;
  private readonly _apiGetTrucksInPlantUrgent: string;

  constructor({
    api,
    apiGetTrucksInPlantByWorkshop,
    apiGetTrucksInParking,
    apiGetUnloadingPointsAverageDlz,
    apiGetTrucksInPlantUnloadingBuffer,
    apiGetTrucksInPlantWaitingToArrive,
    apiGetTrucksInPlantUrgent
  }) {
    super();
    this._api = api;
    this._apiGetTrucksInPlantByWorkshop = apiGetTrucksInPlantByWorkshop;
    this._apiGetTrucksInParking = apiGetTrucksInParking;
    this._apiGetUnloadingPointsAverageDlz = apiGetUnloadingPointsAverageDlz;
    this._apiGetTrucksInPlantUnloadingBuffer =
      apiGetTrucksInPlantUnloadingBuffer;
    this._apiGetTrucksInPlantWaitingToArrive =
      apiGetTrucksInPlantWaitingToArrive;
    this._apiGetTrucksInPlantUrgent = apiGetTrucksInPlantUrgent;
  }

  getTrucksInPlantByWorkshopData({
    queryParams
  }: {
    queryParams: { workshop_id: string; min_dlz_hours: string | number };
  }) {
    return this._api
      .get(
        `${this._apiGetTrucksInPlantByWorkshop}/${queryParams.workshop_id}/${queryParams.min_dlz_hours}`
      )
      .then((res) => {
        const response = new TrucksInAreaListDTO(res);
        return TrucksInfoMapper.trucksInAreaListToDomain(response);
      });
  }

  getTrucksInParkingData() {
    return this._api.get(`${this._apiGetTrucksInParking}`).then((res) => {
      const response = new TrucksInAreaParkingListDTO(res);
      return TrucksInfoMapper.trucksInAreaListToDomain(response);
    });
  }

  getUnloadingPointsAverageDlzData() {
    return this._api
      .get(`${this._apiGetUnloadingPointsAverageDlz}`)
      .then((res) => {
        const response = new UnloadingPointsAverageDlzInfoListDTO(res);
        return TrucksInfoMapper.unloadingPointsAverageDlzInfoListToDomain(
          response
        );
      });
  }

  getTrucksInPlantByUnloadingBufferData() {
    return this._api
      .get(`${this._apiGetTrucksInPlantUnloadingBuffer}`)
      .then((res) => {
        const response = new TrucksInPlantByPointInfoListDTO(res);
        return TrucksInfoMapper.trucksInPlantByPointInfoListToDomain(response);
      });
  }

  getTrucksInPlantWaitingToArriveData() {
    return this._api
      .get(`${this._apiGetTrucksInPlantWaitingToArrive}`)
      .then((res) => {
        const response = new TrucksInPlantByPointInfoListDTO(res);
        return TrucksInfoMapper.trucksInPlantByPointInfoListToDomain(response);
      });
  }

  getTrucksInPlantUrgentData({
    queryParams
  }: {
    queryParams: { workshop_id: string };
  }) {
    return this._api
      .get(`${this._apiGetTrucksInPlantUrgent}/${queryParams.workshop_id}`)
      .then((res) => {
        const response = new TrucksInAreaListDTO(res);
        return TrucksInfoMapper.trucksInAreaListToDomain(response);
      });
  }
}

export default new TrucksInfoRepository({
  api: api,
  apiGetTrucksInPlantByWorkshop: URL.API_GET_TRUCKS_IN_PLANT_BY_WORKSHOP,
  apiGetTrucksInParking: URL.API_GET_TRUCKS_IN_PARKING,
  apiGetUnloadingPointsAverageDlz: URL.API_GET_UNLOADING_POINTS_AVERAGE_DLZ,
  apiGetTrucksInPlantUnloadingBuffer:
    URL.API_GET_TRUCKS_IN_PLANT_UNLOADING_BUFFER,
  apiGetTrucksInPlantWaitingToArrive:
    URL.API_GET_TRUCKS_IN_PLANT_WAITING_TO_ARRIVE,
  apiGetTrucksInPlantUrgent: URL.API_GET_TRUCKS_IN_PLANT_URGENT
});

export { TrucksInfoRepository };
